<template>
  <div>
    <a
      v-if="currentCampaign"
      class="umeng-uc-wd-ad-click"
      :data-umeng-name="currentCampaign ? currentCampaign.name : ''"
      :data-umeng-channel="channel"
      :data-umeng-link-url="currentCampaign ? currentCampaign.linkUrl : ''"
      @click="goToCampaign"
    >
      <svg
        viewBox="0 0 40 20"
        class="fanning-packets-icon"
        style="width: 0.75rem; height: auto; display: block; margin-right: 0.1rem; cursor: pointer; overflow: visible;"
      >
        <g class="tap-hint">
          <circle cx="24" cy="12" r="2" stroke="#FFD700" fill="none" />
          <circle cx="24" cy="12" r="2" stroke="#FFD700" fill="none" />
        </g>
        <g class="packet-back">
          <rect x="18" y="3" width="12" height="15" rx="1" fill="#D70000" />
          <path d="M18 3 L24 9 L30 3" stroke="#990000" stroke-width="1" fill="none" stroke-linejoin="round" />
          <circle cx="24" cy="12" r="2.5" fill="#FFD700" />
          <rect x="23.25" y="11.25" width="1.5" height="1.5" fill="#D70000" />
        </g>
        <g class="packet-front">
          <rect x="18" y="3" width="12" height="15" rx="1" fill="#D70000" />
          <path d="M18 3 L24 9 L30 3" stroke="#990000" stroke-width="1" fill="none" stroke-linejoin="round" />
          <circle cx="24" cy="12" r="2.5" fill="#FFD700" />
          <rect x="23.25" y="11.25" width="1.5" height="1.5" fill="#D70000" />
        </g>
      </svg>
    </a>
    <transition name="fade">
      <div v-if="showCampaignPage" class="mask" />
    </transition>
    <transition name="slide">
      <div v-if="showCampaignPage" class="campaign-page-container">
        <iframe :src="currentCampaign.linkUrl" class="campaign-page" loading="lazy" />
        <button class="campaign-page-close-btn" @click="showCampaignPage = false">
          关闭
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/plugins/api'
import { removeQueryParam } from '@/utils/helper'
import { mapState } from 'vuex'

export default {
  name: 'BankMatchCampaignTip',
  data() {
    return {
      showPopup: false,
      currentCampaign: {
        linkUrl: `${process.env.VUE_APP_OFFICIAL_PAGE_M}/cn/zt/fixed-withdrawal-promo.html`
      },
      adPosition: '8',
      channel: 'WITHDRAW',
      showCampaignPage: false
    }
  },
  computed: {
    ...mapState(['pageType', 'user'])
  },
  watch: {
    currentCampaign: function(newVal) {
      this.currentCampaign = newVal
      this.showPopup = !!newVal
    }
  },
  mounted() {
    // this.queryForApp()
  },
  methods: {
    queryForApp() {
      const data = {
        channel: this.channel
      }
      api.queryForAppH5(data).then(res => {
        if (res && res.data && res.data.code == 200 && res.data.ch_msg[this.adPosition]) {
          this.currentCampaign = res.data.ch_msg[this.adPosition].length > 0 ? res.data.ch_msg[this.adPosition][0] : null
        }
      })
    },
    goToCampaign() {
      if (this.pageType == 'app') {
        this.showCampaignPage = true
        return
      }
      window.open(removeQueryParam(this.currentCampaign.linkUrl, 'noneheader'), '_blank')
    }
  }
}
</script>
<style>
/* --- SEQUENCED ANIMATION START --- */
/* Total Loop Duration: 5 Seconds
   0s - 1.5s: Ripples (Packets still)
   1.5s - 4.0s: Fanning (Ripples hidden)
   4.0s - 5.0s: Pause (All still)
*/

/* 1. RIPPLE SEQUENCE */
@keyframes ripple-sequence {
  0% {
    transform: scale(1);
    opacity: 1;
    stroke-width: 2.5;
  }
  20% {
    /* Action finishes at 1s (20% of 5s) */
    transform: scale(8);
    opacity: 0;
    stroke-width: 0.5;
  }
  100% {
    /* Stay hidden for the rest of the loop */
    transform: scale(8);
    opacity: 0;
    stroke-width: 0.5;
  }
}

.tap-hint circle {
  transform-origin: 24px 12px;
  /* Runs for 5s total, but action happens in first 20% */
  animation: ripple-sequence 5s ease-out infinite;
  will-change: transform, opacity;
}

/* Stagger the second ripple slightly */
.tap-hint circle:nth-child(2) {
  animation-delay: 0.4s;
}

/* 2. FANNING SEQUENCE (BACK) */
@keyframes fan-back-sequence {
  0%, 35% {
    /* IDLE: Wait for ripple to finish (0s - 1.75s) */
    transform: translateX(0) rotate(0deg);
  }
  50%, 60% {
    /* ACTION: Fan out (2.5s - 3s) */
    transform: translateX(-5px) rotate(-15deg);
  }
  75%, 100% {
    /* RETURN & IDLE: Close back up (3.75s - 5s) */
    transform: translateX(0) rotate(0deg);
  }
}

.packet-back {
  transform-origin: 24px 18px;
  animation: fan-back-sequence 5s ease-in-out infinite;
  will-change: transform;
}

/* 3. FANNING SEQUENCE (FRONT) */
@keyframes fan-front-sequence {
  0%, 35% {
    /* IDLE: Wait for ripple to finish */
    transform: translateX(0) rotate(0deg);
  }
  50%, 60% {
    /* ACTION: Fan out */
    transform: translateX(5px) rotate(15deg);
  }
  75%, 100% {
    /* RETURN & IDLE */
    transform: translateX(0) rotate(0deg);
  }
}

.packet-front {
  transform-origin: 24px 18px;
  animation: fan-front-sequence 5s ease-in-out infinite;
  will-change: transform;
  filter: drop-shadow(1px 0 1px rgba(0,0,0,0.2));
}

/* --- SEQUENCED ANIMATION END --- */

.mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.campaign-page-container {
    z-index: 999999;
    position: absolute;
    left: 0;
    right: 0;
    margin-left: auto;
    margin-right: auto;
    height: 97.5vh;
    width: 100%;
    top: 0;
}

iframe.campaign-page {
    width: 95%;
    height: 100%;
    margin-left: 2.5%;
    margin-top: 2.5%;
}

button.campaign-page-close-btn {
    position: absolute;
    right: 0rem;
    top: 0.35rem;
    margin-right: 0.3rem;
    height: 0.75rem;
    width: 1.4rem;
    border-radius: 0.1rem;
    border: 0;
    font-size: 0.25rem;
    color: #ffff;
    background: #444;
    line-height: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  overflow: hidden;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateY(100%);
}

.slide-enter-to,
.slide-leave-from {
  transform: translateY(0);
}
</style>
